export function clamp(value: number, min: number, max: number): number {
  return Math.min(max, Math.max(min, value));
}

export function finiteOr(value: unknown, fallback: number): number {
  return typeof value === "number" && Number.isFinite(value) ? value : fallback;
}

export function nonNegative(value: unknown, fallback = 0): number {
  return Math.max(0, finiteOr(value, fallback));
}

export function nonNegativeInteger(value: unknown, fallback = 0): number {
  return Math.floor(nonNegative(value, fallback));
}

export function normalizeDegrees(degrees: number): number {
  return ((degrees % 360) + 360) % 360;
}

export function shortestAngleDistanceDegrees(a: number, b: number): number {
  const diff = Math.abs(normalizeDegrees(a) - normalizeDegrees(b));
  return Math.min(diff, 360 - diff);
}

export function formatCompact(value: number): string {
  if (value < 1_000) {
    return Math.floor(value).toString();
  }

  const units = [
    { value: 1_000_000_000, suffix: "B" },
    { value: 1_000_000, suffix: "M" },
    { value: 1_000, suffix: "K" }
  ];

  const unit = units.find((candidate) => value >= candidate.value);
  if (!unit) {
    return Math.floor(value).toString();
  }

  const scaled = value / unit.value;
  return `${scaled >= 100 ? scaled.toFixed(0) : scaled.toFixed(1)}${unit.suffix}`;
}
